import axios from "axios";
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import closeButton from "../../Assets/Images/close-btn.png";
import { AddColorApi } from "../../Utils/API/ApiCall";
import { ToastContainer, toast } from "react-toastify";
import { Col, Form, Row } from "react-bootstrap";

const CreateModal = ({
  images,
  head,
  detail,
  button,
  placeholder,
  onHide,
  ...props
}) => {
  const [colorName, setColorName] = useState("");
  const [errorEmpty, setErrorEmpty] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChangeColorName = (e) => {
    e.preventDefault();
    setColorName(e.target.value);
  };
  const addcolor = async (e) => {
    e.preventDefault();
    let check = true;
    if (!colorName) {
      setErrorEmpty(true);
      setErrorMsg("Color Name should not be empty");
      check = false;
    } else if (colorName) {
      if (/^\s+$/.test(colorName) === true) {
        setErrorEmpty(true);
        setErrorMsg("Color Name should not be empty");
        check = false;
      } else {
        setErrorEmpty(false);
      }
    } else {
      setErrorMsg(false);
    }

    if (check === true) {
      const data = {
        color_name: colorName,
      };
      const Response = await AddColorApi(data);
      if (Response.status == 200) {
        toast.success(Response.message);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else if (Response.status == 400) {
        toast.error(Response.message);
      } else {
        toast.error(Response.message);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    }
  };

  const handleClose = () =>{
    window.location.reload();
  }


  return (
    <>
      <div className="Modal">
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <img
              src={closeButton}
              className="closeButton"
              alt="closeButton"
              onClick={handleClose}
            />
            <div className="modal-image">
              <img
                loading="lazy"
                src={images}
                alt="category image"
                className="modal_Head_Image"
              />
            </div>
            <h3>{head}</h3>
            {/* <h4>{detail}</h4> */}
            <Form onSubmit={addcolor}>
              <div className="Modal-input">
                <input
                  type="text"
                  placeholder={placeholder}
                  maxLength={50}
                  value={colorName}
                  onChange={handleChangeColorName}
                ></input>
              </div>
              <p className="err-msg">{errorEmpty ? errorMsg : ""}</p>
              <button className="modal_Button" onSubmit={addcolor}>
                Add
              </button>
            </Form>
            {/* <p className="error-msg">erroe</p><br></br> */}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default CreateModal;
